<template>
    <v-dialog
      v-model="isVisible"
      no-click-animation
      max-width="50%">
      <v-card>
        <v-layout row wrap>
          <v-flex xs5>
            <v-card-title class="headline">{{title}}</v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout mt-2 row wrap>
            <v-flex xs12>
              <v-text-field
                readonly
                v-model="officialItem.displayId" :label="`案件編號`"></v-text-field>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>

          <v-layout mt-2 row wrap v-if="showComment">
            <v-flex xs12>
              <v-textarea v-if="editIndex === 2"
                  solo
                  name="input-7-4"
                  :label="documentLabel"
                  v-model="file.comment"
              ></v-textarea>
              <v-text-field v-else
                v-model="file.comment" :label="documentLabel">
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="showComment && editIndex === 2">
            <v-checkbox
              v-model="officialItem.forceTryForExam"
              label="強制爭取"
            ></v-checkbox>
          </v-layout>

          <v-container v-if="editIndex===3">
            <v-layout row wrap>
              <v-flex xs12 md12>
              <v-text-field
                v-model="formalNoteItem.tel" :label="`電話號碼`"></v-text-field>
              </v-flex>
              <v-flex xs12 md12>照會日期：</v-flex>
              <v-flex xs12 md12>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-select
                      v-model="applyDate.year"
                      :items="yearList"
                      item-text="name"
                      item-value="key"
                      label="年"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      v-model="applyDate.month"
                      :items="monthList"
                      item-text="name"
                      item-value="key"
                      label="月"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      v-model="applyDate.day"
                      :items="dayList"
                      item-text="name"
                      item-value="key"
                      label="日"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      v-model="applyDate.hour"
                      :items="hourList"
                      item-text="name"
                      item-value="key"
                      label="時"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      v-model="applyDate.minute"
                      :items="minuteList"
                      item-text="name"
                      item-value="key"
                      label="分"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 md12>
                <v-switch
                  v-model="isNowCallout"
                  :label="`現可照會`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  solo
                  name="input-7-4"
                  label="備註描述"
                  v-model="formalNoteItem.descript"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container v-if="showUpdateView">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <div class="dropbox">
                  <input
                    type="file"
                    ref="file"
                    multiple
                    @change="filesChange($event.target.name, $event.target.files);"
                    accept=".pdf"
                    class="input-file"
                  />
                  <p>
                    請將PDF檔案拖到此處
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container v-if="(attachmentFile && attachmentFile.length)">
            <v-layout row wrap v-for="zipFile in attachmentFile"
             :key="`${zipFile.caseId}`">
              <v-flex xs9 md9>
                <v-chip class="ma-3" label x-large v-if="editIndex === 0 || editIndex === 2">
                  {{`${zipFile.name}文件`}}
                </v-chip>
                <v-chip class="ma-3" label x-large v-if="editIndex === 1">
                  {{zipFile.name}}
                </v-chip>
              </v-flex>
              <v-flex xs2 md2>
                <v-btn color="error"
                  @click="removeFile(zipFile.caseId)">
                  刪除
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="mr-2 subheading red--text" v-if="saveLoading">案件上傳中 請勿關閉視窗</span>
          <v-btn class="primary" dark text :loading="saveLoading" @click="save">確認上傳</v-btn>
          <v-btn class="red" dark text  v-if="saveLoading" @click="cancelSave">取消上傳</v-btn>
        </v-card-actions>
      </v-card>
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="messageDialog.showCancel"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>
    </v-dialog>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from "vuex";
import AlertView from "../components/AlertView";
import AttachmentModel from '../models/AttachmentModel';
import { zipFiles } from '@/pages/utils/zip';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "InstallmentPaymentDialog",
  props: {
    title:String,
    loading: Boolean,
    visible: Boolean,
    displayId: String,
    editIndex: Number, // 0.請款 1.審件補件 2.申覆 3.重新照會
    cellphone: String
  },
  components: {AlertView },
  data() {
    return {
      width: md.phone() ? "100%" : "70%",
      officialItem: {
        displayId: '',
        salesId: '',
        attachmentFile: [],
        forceTryForExam: false,
      },
      isMobile: md.phone(),
      messageDialog: {
        title: "",
        content: "",
        visible: false,
        showCancel: false,
        confirm: () => {},
        cancel: () => {}
      },
      saveLoading: false,
      isVisible:false,
      file:{
        comment:'',
        label:'',
      },
      attachmentFile :[],
      formalNoteItem :{ // 重新照會專用
      },
      defaultNoteItem: {
        salesId: '',
        displayId: '',
        descript:'', //備註描述
        tel:this.cellphone,
        calloutDate:'',
        nowCallout:'N' // Y 或 N
      },
      isNowCallout:false,
      applyDate:{
        year: '',
        month: '',
        day:'',
        hour:'',
        minute:'00'
      },
      timeId: null,
    };
  },
  created() {

  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    showUpdateView() {
      return this.editIndex === 1 || (this.editIndex !== 3 && this.attachmentFile.length === 0);
    },
    showComment() {
      if (this.editIndex > 0 && this.editIndex < 3) {
        if (this.editIndex === 2 && this.attachmentFile.length > 0) {
          return false
        }
        return true
      } else {
        return false
      }
    },
    documentLabel() {
      if(this.editIndex === 1) {
        return '補件說明'
      } else if (this.editIndex === 2) {
        return '申覆內容'
      } else {
        return '裕富請款'
      }
    },
    yearList() {
      const start = new Date().getFullYear() + 1;
      const end = new Date().getFullYear();
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i}`, name: `${i}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: '01', key: '01' },
        { name: '02', key: '02' },
        { name: '03', key: '03' },
        { name: '04', key: '04' },
        { name: '05', key: '05' },
        { name: '06', key: '06' },
        { name: '07', key: '07' },
        { name: '08', key: '08' },
        { name: '09', key: '09' },
        { name: '10', key: '10' },
        { name: '11', key: '11' },
        { name: '12', key: '12' },
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i += 1) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    hourList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 24; i += 1) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    minuteList() {
      return [{ name: '00', key: '00' },
        { name: '15', key: '15' },
        { name: '30', key: '30' },
        { name: '45', key: '45' }];
    }
  },
  watch:{
    cellphone(value) {
      console.log(`cellphone === ${value}`)
      this.formalNoteItem.tel = value
    },
    displayId(value) {
      console.log(`displayId === ${value}`)
      this.officialItem.displayId = value;
    },

    visible(value){
      this.isVisible = value;
      if (value === true){
        this.clearFile();
      }
    },
    isVisible(value){
      if(!value)
      {
        this.file.comment = '';
        this.attachmentFile = []
        this.$emit('closeEvent');
      } else {
        this.formalNoteItem = Object.assign({}, this.defaultNoteItem);
        this.applyDate = {
          year: '',
          month: '',
          day:'',
          hour:'',
          minute:'00'
        };
      }
    },
    isNowCallout(value){
      if (value === true){
        const now = new Date();
        this.applyDate.year = `${now.getFullYear()}`;
        const month = now.getMonth()+1;
        const day = now.getDate();
        const hour = now.getHours();
        this.applyDate.month = month < 10 ? `0${month}` : `${month}`;
        this.applyDate.day =  day < 10 ? `0${day}` : `${day}`;
        this.applyDate.hour = hour < 10 ? `0${hour}` : `${hour}`;
        this.applyDate.minute = `00`;
      }
    }
  },
  methods: {
    ...mapActions(['requestPayment', 'requestSupplement', 'requestForExam', 'uploadImageData', 'reCallout']),
    cancelSave(){
      if (this.timeId !== null){
        clearTimeout(this.timeId);
        this.timeId = null;
      }
      this.saveLoading = false;
    },
    async save() {
      if(this.attachmentFile.length === 0 && this.editIndex === 1) {
        this.showMessageDialog('錯誤', `請上傳pdf檔案`, true, ()=>{},()=>{});
        return;
      }

      if ( this.editIndex === 3 &&
        (!this.applyDate.year || !this.applyDate.month || !this.applyDate.day || !this.applyDate.hour || !this.applyDate.minute)) {
        this.showMessageDialog('錯誤', `請選擇照會時間`, true, ()=>{},()=>{});
        return;
      }
      console.log(`this.timeId == `,this.timeId);

      if (this.timeId === null){
        this.saveLoading = true;
        this.timeId = setTimeout(async ()=>{
          await this.saveEvent();
          this.timeId = null;
        }, 5000);
      }
    },
    async saveEvent(){
      this.officialItem.salesId = this.getUserInfo.salesId;
      this.officialItem.attachmentFile = []
      let supplement = []
      let comment = '';

      for (let index = 0; index < this.attachmentFile.length; index++) {
        const element = this.attachmentFile[index];
        const newZip = await zipFiles([element]);
        const file = {
          file_index: index,
          file_body_encode: newZip,
          file_size: element.file_size,
          content_type: 'zip'
        }

        console.log(`file === ${JSON.stringify(file)}`)

        this.officialItem.attachmentFile.push(file)

        if(this.editIndex > 0) {
          if(index === 0) {
            comment = element.name
          }
          let file = {
            item:"00",
            comment: element.name
          }
          supplement.push(file)
        }
      }
      this.saveLoading = true

      const extIndex = comment.lastIndexOf('.');
      if (extIndex !== -1) {
        comment = comment.substr(0, extIndex);
      }

      let result = {}
      if(this.editIndex === 0) {
        if(this.attachmentFile.length > 0) {
          if (this.officialItem.attachmentFile.length === 0) {
            this.showMessageDialog('錯誤', `沒有附加檔案`, true, ()=>{},()=>{});
            return;
          }

          const fileData = this.attachmentFile[0].firebaseData;
          const fileName = `${this.officialItem.displayId}_${new Date().getTime()}.pdf`;
          const uploadResult = await this.uploadImageData({
            name: fileName,
            image: fileData,
          });
          this.officialItem.requestPaymentURL = uploadResult;
        }

        result = await this.requestPayment(this.officialItem)
      } else if (this.editIndex === 1) {
        this.officialItem.comment = comment
        this.officialItem.supplement = supplement
        result = await this.requestSupplement(this.officialItem)
      } else if (this.editIndex === 2) {
        if(this.attachmentFile.length > 0) {
          this.officialItem.comment = comment;
        } else {
          this.officialItem.comment = this.file.comment;
        }
        if (this.officialItem.attachmentFile.length > 0) {
          const fileData = this.attachmentFile[0]
          const fileName = `${this.officialItem.displayId}_${new Date().getTime()}.pdf`;
          const uploadResult = await this.uploadImageData({
                name: fileName,
                image: fileData.firebaseData,
              });
          this.officialItem.fileURL = uploadResult
        }
        result = await this.requestForExam(this.officialItem)
      } else if (this.editIndex === 3) {
        this.formalNoteItem.salesId = this.getUserInfo.salesId;
        this.formalNoteItem.displayId = this.officialItem.displayId;
        this.formalNoteItem.nowCallout = this.isNowCallout ? 'Y' : 'N';
        this.formalNoteItem.calloutDate = `${this.applyDate.year}${this.applyDate.month}${this.applyDate.day}${this.applyDate.hour}${this.applyDate.minute}00`
        result = await this.reCallout(this.formalNoteItem)
      }
      console.log(`save === ${JSON.stringify(this.officialItem)}`)

      this.saveLoading = false;

      const data = result.data
      if (!data) {
        this.showMessageDialog('錯誤', `請洽工程人員處理`, true, ()=>{},()=>{});
        this.clearFile();
      } else if (data.statusCode === 0) {
        this.showMessageDialog('成功','上傳成功', true, ()=>{},()=>{});
        this.isVisible = false
        this.clearFile();
      } else {
        this.showMessageDialog('錯誤', data.message, true, ()=>{},()=>{});
        this.clearFile();
      }
    },
    clearFile(){
      if (this.$refs.file){
        this.$refs.file.value = null;
      }
      this.officialItem.fileURL = '';
    },
    filesChange(fieldName, fileList) {
      const files = Object.values(this.$refs.file.files);
      console.log(`filesChange == `, files);
      if (!fileList.length) return;
      if (fileList.length > 1) {
        this.showMessageDialog('錯誤','一次只能上傳一個PDF檔', true, ()=>{},()=>{});
        this.clearFile();
        return;
      }
      if ((this.file.comment.replace(/(^s*)|(s*$)/g, "").length === 0　|| !this.file.comment) && this.editIndex > 0) {
        this.showMessageDialog('錯誤',`請填寫申覆內容`, true, ()=>{
        },()=>{});
        this.clearFile();
        return;
      }
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((i, x) => {
          const file = {
            name: fileList[x].name,
            image: fileList[x],
            size: fileList[x].size,
            type: fileList[x].type,
          };

          this.createFile(i, file);
        });
    },
    createFile(i, file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        console.log(`pdf file ${JSON.stringify(data)}`)
        if (data.indexOf('data:application/pdf') > -1) {
          const files = data.split(',');
          const name = this.file.comment ? this.file.comment : this.documentLabel
          const pdfFile = files.length > 1 ? files[1] : files[0]
          let attachmentItem = new AttachmentModel();
          attachmentItem.caseId = Math.uuidFast();
          attachmentItem.file_index = 0;
          attachmentItem.file_body_encode = pdfFile;
          attachmentItem.file_size = data.length;
          attachmentItem.firebaseData = data; // for firebase upload
          attachmentItem.content_type = 'pdf';
          attachmentItem.name = `${name}_${new Date().getTime()}.pdf`;
          console.log(`comment === ${this.file.comment } label === ${this.documentLabel}`)
          this.file.comment = '';

          this.attachmentFile.push(attachmentItem);
        } else {
          this.showMessageDialog('錯誤','只能上傳pdf檔', true, ()=>{},()=>{});
        }
      };
      reader.readAsDataURL(file.image);
    },
    removeFile(caseId) {
      console.log(`remove file ${JSON.stringify(caseId)}`);
      this.attachmentFile.forEach((item, index) => {
        if (item.caseId === caseId) {
          this.attachmentFile.splice(index, 1);
        }
      });
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      console.log(`showMessageDialog ${visible}`)
      this.messageDialog.title = title;
      this.messageDialog.content = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };
      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  }
};
</script>


<style scoped>
.pdf-container{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
  }

.imgBox {
  box-shadow: 4px 4px 12px -2px rgba(20%, 20%, 40%, 0.5);
}

.image-view {
  width: 100%;
  height: 180px;
  object-fit: scale-down;
}

.image-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.selectedIamge {
  border-radius: 50%;
  background-color: #44ad53;
  height: 30px;
  width: 30px;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/InstallmentPaymentDialog.vue